
import axiosClient from './axiosClient';

const isFile = (value) =>
  typeof File !== 'undefined' && value instanceof File;

const appendPayload = (formData, value, path) => {
  if (value === undefined || value === null) {
    return;
  }

  if (isFile(value) || value instanceof Blob) {
    formData.append(path, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      appendPayload(formData, item, `${path}[${index}]`);
    });
    return;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([key, item]) => {
      appendPayload(
        formData,
        item,
        `${path}[${key}]`
      );
    });
    return;
  }

  if (typeof value === 'boolean') {
    formData.append(path, value ? '1' : '0');
    return;
  }

  formData.append(path, String(value));
};

const appendImageCollection = (
  formData,
  fieldName,
  images,
  maxPerItem
) => {
  if (!images) return;

  Object.entries(images).forEach(([key, files]) => {
    const collection = Array.isArray(files)
      ? files
      : [files];

    collection
      .filter(isFile)
      .slice(0, maxPerItem)
      .forEach((file, index) => {
        formData.append(
          `${fieldName}[${key}][${index}]`,
          file
        );
      });
  });
};

const menuImportsApi = {
  list(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/menu-imports`,
      { params }
    );
  },

  scan(establishmentId, files, targetLocales = []) {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files[]', file);
    });

    targetLocales.forEach((locale) => {
      formData.append('target_locales[]', locale);
    });

    return axiosClient.post(
      `/establishments/${establishmentId}/menu-imports/scan`,
      formData
    );
  },

  show(establishmentId, importId) {
    return axiosClient.get(
      `/establishments/${establishmentId}/menu-imports/${importId}`
    );
  },

  confirm(
    establishmentId,
    importId,
    payload = {},
    categoryImages = {},
    productImages = {}
  ) {
    const hasImages =
      Object.values(categoryImages).some(Boolean) ||
      Object.values(productImages).some(Boolean);

    const endpoint =
      `/establishments/${establishmentId}` +
      `/menu-imports/${importId}/confirm`;

    if (!hasImages) {
      return axiosClient.post(endpoint, payload);
    }

    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      appendPayload(formData, value, key);
    });

    appendImageCollection(
      formData,
      'category_images',
      categoryImages,
      1
    );

    appendImageCollection(
      formData,
      'product_images',
      productImages,
      5
    );

    return axiosClient.post(endpoint, formData);
  },

  remove(establishmentId, importId) {
    return axiosClient.delete(
      `/establishments/${establishmentId}/menu-imports/${importId}`
    );
  },
};

export default menuImportsApi;
